import { PropsWithChildren } from 'react';

import { VariantProps, cva } from 'class-variance-authority';

import { cn } from '../lib';
import { Header } from './header';

const variants = cva('rounded-[28px] bg-base-300', {
  variants: {
    size: {
      lg: 'p-5',
      md: 'px-4 py-3',
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});

interface GroupInnerProps
  extends PropsWithChildren,
    VariantProps<typeof variants> {
  className?: string;
}

export const GroupInner = ({ children, className, size }: GroupInnerProps) => {
  return <div className={variants({ size, className })}>{children}</div>;
};

interface GroupProps extends PropsWithChildren {
  title?: string;
  groupClassName?: string;
  headerClassName?: string;
}

export const Group = ({
  children,
  title,
  groupClassName,
  headerClassName,
}: GroupProps) => {
  return (
    <div className="flex flex-col [&:not(:first-child)]:mt-5">
      {title && (
        <Header
          titleProps={{ className: cn('mb-5', headerClassName) }}
          title={title}
        />
      )}

      <div className={cn('flex flex-col gap-y-3', groupClassName)}>
        {children}
      </div>
    </div>
  );
};
